var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWebIconDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4895",
    "data-name": "Rectangle 4895",
    width: 25.672,
    height: 25.578,
    fill: "#ef7b13"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13190",
    "data-name": "Group 13190",
    transform: "translate(-822 -990)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_591",
    "data-name": "Ellipse 591",
    transform: "translate(822 990)",
    fill: "#000000ff",
    stroke: "rgba(255, 255, 255, 0.3)",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 22,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 21.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12616",
    "data-name": "Group 12616",
    transform: "translate(831.167 999.167)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12615",
    "data-name": "Group 12615",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45285",
    "data-name": "Path 45285",
    d: "M343.359,232.006c-.066.451-.127.9-.2,1.352a12.124,12.124,0,0,1-1.072,3.339,12.435,12.435,0,0,1-1.532,2.425c-.07.087-.114.2-.275.114a15.7,15.7,0,0,0-3.346-1.314,24.255,24.255,0,0,0,.925-6.367h5.5Z",
    transform: "translate(-317.687 -218.327)",
    fill: "#ef7b13"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45286",
    "data-name": "Path 45286",
    d: "M343.67,89.033h-5.5a24.08,24.08,0,0,0-.908-6.271l3.534-1.408c.357.528.782,1.094,1.14,1.7a12.3,12.3,0,0,1,1.5,3.976c.087.457.124.923.185,1.385.01.073.032.145.048.218Z",
    transform: "translate(-317.998 -76.707)",
    fill: "#ef7b13"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45287",
    "data-name": "Path 45287",
    d: "M0,231.95H5.532a24.19,24.19,0,0,0,.927,6.333c-.349.108-.69.186-1.009.317-.769.315-1.53.649-2.289.987a.213.213,0,0,1-.31-.068,12.762,12.762,0,0,1-2.579-5.563c-.127-.651-.18-1.317-.272-2.007",
    transform: "translate(0 -218.699)",
    fill: "#ef7b13"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45288",
    "data-name": "Path 45288",
    d: "M3.518,81.545l3.507,1.4A23.99,23.99,0,0,0,6.118,89.2H.62a12.808,12.808,0,0,1,2.9-7.651",
    transform: "translate(-0.585 -76.887)",
    fill: "#ef7b13"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45289",
    "data-name": "Path 45289",
    d: "M112.8,231.932h5.939v5.517a24.713,24.713,0,0,0-5.033.6,22.693,22.693,0,0,1-.906-6.119",
    transform: "translate(-106.355 -218.682)",
    fill: "#ef7b13"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45290",
    "data-name": "Path 45290",
    d: "M238.2,238.121a24.622,24.622,0,0,0-5.041-.6v-5.516H239.1a22.736,22.736,0,0,1-.9,6.112",
    transform: "translate(-219.838 -218.755)",
    fill: "#ef7b13"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45291",
    "data-name": "Path 45291",
    d: "M118.769,114.742h-5.937a22.674,22.674,0,0,1,.9-6.116,24.7,24.7,0,0,0,5.034.606Z",
    transform: "translate(-106.386 -102.421)",
    fill: "#ef7b13"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45292",
    "data-name": "Path 45292",
    d: "M233.255,109.235a24.7,24.7,0,0,0,5.033-.606,22.841,22.841,0,0,1,.906,6.109h-5.939Z",
    transform: "translate(-219.93 -102.423)",
    fill: "#ef7b13"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45293",
    "data-name": "Path 45293",
    d: "M138.345,0V5.9a22.985,22.985,0,0,1-4.755-.565A9.481,9.481,0,0,1,136.829.592,3.441,3.441,0,0,1,138.345,0",
    transform: "translate(-125.958 -0.002)",
    fill: "#ef7b13"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45294",
    "data-name": "Path 45294",
    d: "M233.188,0a3.745,3.745,0,0,1,1.78.774,7.469,7.469,0,0,1,2.09,2.586c.329.632.6,1.293.913,1.968a23.031,23.031,0,0,1-4.784.572Z",
    transform: "translate(-219.867)",
    fill: "#ef7b13"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45295",
    "data-name": "Path 45295",
    d: "M132.962,345.085a22.887,22.887,0,0,1,4.786-.562v5.894a3.775,3.775,0,0,1-1.847-.828,7.436,7.436,0,0,1-1.978-2.455c-.344-.654-.63-1.337-.961-2.049",
    transform: "translate(-125.366 -324.842)",
    fill: "#ef7b13"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45296",
    "data-name": "Path 45296",
    d: "M233.176,344.542a22.731,22.731,0,0,1,4.753.552c-.125.314-.235.614-.362.907a9.43,9.43,0,0,1-2.227,3.344,4.047,4.047,0,0,1-2.164,1.093Z",
    transform: "translate(-219.855 -324.859)",
    fill: "#ef7b13"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45297",
    "data-name": "Path 45297",
    d: "M287.636,10.813a14.977,14.977,0,0,1-3.13,1.205,11.5,11.5,0,0,0-2.875-4.7c1.289-.01,4.942,2.12,6.005,3.5",
    transform: "translate(-265.542 -6.898)",
    fill: "#ef7b13"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45298",
    "data-name": "Path 45298",
    d: "M69.329,7.137c-.529.71-1.137,1.415-1.617,2.2s-.827,1.642-1.24,2.482a12.688,12.688,0,0,1-3.039-1.194,12.647,12.647,0,0,1,5.9-3.486",
    transform: "translate(-59.809 -6.729)",
    fill: "#ef7b13"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45299",
    "data-name": "Path 45299",
    d: "M62.964,359.328a14.917,14.917,0,0,1,3.147-1.211,11.769,11.769,0,0,0,2.867,4.723,12.586,12.586,0,0,1-6.014-3.511",
    transform: "translate(-59.367 -337.658)",
    fill: "#ef7b13"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45300",
    "data-name": "Path 45300",
    d: "M284.717,357.067l3.176,1.221a12.722,12.722,0,0,1-6.061,3.563,11.823,11.823,0,0,0,2.884-4.784",
    transform: "translate(-265.733 -336.669)",
    fill: "#ef7b13"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebIconDark);
export default __webpack_public_path__ + "static/media/web_icon_dark.080167c29198f79a2cd8e0c3442a2a91.svg";
export { ForwardRef as ReactComponent };